/**
 * @name: goodsManagement.js
 * @description: 商品管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/goods/materiel/list',
    name: 'materielList',
    component: () => import('@/views/goods/materiel/List'),
    meta: {
      title: '物料扩展信息'
    }
  },
  {
    path: '/goods/materiel/add',
    name: 'materielAdd',
    component: () => import('@/views/goods/materiel/Add'),
    meta: {
      parentRoutePath: "materielList",
      title: '新增物料扩展信息'
    }
  },
  {
    path: '/goods/sku/list',
    name: 'skuList',
    component: () => import('@/views/goods/sku/List'),
    meta: {
      title: '商品列表'
    }
  },
  {
    path: '/goods/sku/add',
    name: 'skuAdd',
    component: () => import('@/views/goods/sku/Add'),
    meta: {
      title: '新增商品',
      parentRoutePath: 'skuList'
    }
  },
  {
    path: '/goods/price/list',
    name: 'priceList',
    component: () => import('@/views/goods/price/List'),
    meta: {
      title: '基础价格管理'
    }
  },
  {
    path: '/goods/price/detail',
    name: 'priceDetail',
    component: () => import('@/views/goods/price/Detail'),
    meta: {
      title: '价格详情',
      parentRoutePath: 'priceList'
    }
  },
  {
    path: '/goods/price/platformdetail',
    name: 'platformdetail',
    component: () => import('@/views/goods/price/PlatformDetail'),
    meta: {
      title: '价格详情',
      parentRoutePath: 'platformPriceList'
    }
  },
  {
    path: '/goods/price/platformlist',
    name: 'platformPriceList',
    component: () => import('@/views/goods/price/PlatformList'),
    meta: {
      title: '平台销售价格管理'
    }
  },
  {
    path: '/goods/category/categorylist',
    name: 'categoryList',
    component: () => import('@/views/goods/category/CategoryList'),
    meta: {
      title: '分类管理'
    }
  },
  {
    path: '/goods/category/attributelist',
    name: 'attributeList',
    component: () => import('@/views/goods/category/AttributeList'),
    meta: {
      title: '属性管理'
    }
  },
  {
    path: '/goods/category/attributeadd',
    name: 'attributeAdd',
    component: () => import('@/views/goods/category/AttributeAdd'),
    meta: {
      title: '新增属性',
      parentRoutePath: '/goods/category/attributelist'
    }
  },
  {
    path: '/goods/brand/list',
    name: 'brandManagement',
    component: () => import('@/views/goods/brand/List'),
    meta: {
      title: '品牌管理'
    }
  },
  {
    path: '/goods/brand/add',
    name: 'brandAdd',
    component: () => import('@/views/goods/brand/Add'),
    meta: {
      title: '新增品牌',
      parentRoutePath: 'brandManagement'
    }
  },
  {
    path: '/goods/evaluate/list',
    name: 'evaluateManagement',
    component: () => import('@/views/goods/evaluate/List'),
    meta: {
      title: '评价管理'
    }
  },
  {
    path: '/goods/evaluate/add',
    name: 'evaluateDetail',
    component: () => import('@/views/goods/evaluate/Add'),
    meta: {
      title: '评价详情',
      parentRoutePath: 'evaluateManagement'
    }
  },
  {
    path: '/goods/country/list',
    name: 'countryManagement',
    component: () => import('@/views/goods/country/List'),
    meta: {
      title: '品牌归属国管理'
    }
  },
  {
    path: '/goods/quota/list',
    name: 'quotaManagement',
    component: () => import(/* webpackChunkName: "quotaManagement" */ '@/views/goods/quota/List'),
    meta: {
      title: '配额管理',
      parentRoutePath: "skuList"
    }
  },
  {
    path: '/goods/quota/add',
    name: 'quotaAdd',
    component: () => import(/* webpackChunkName: "quotaManagement" */ '@/views/goods/quota/Add'),
    meta: {
      title: '配额详情',
      parentRoutePath: "quotaManagement"
    }
  },
];
